import { render, staticRenderFns } from "./CutoffForm.vue?vue&type=template&id=1b862021&scoped=true"
import script from "./CutoffForm.vue?vue&type=script&lang=ts"
export * from "./CutoffForm.vue?vue&type=script&lang=ts"
import style0 from "./CutoffForm.vue?vue&type=style&index=0&id=1b862021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b862021",
  null
  
)

export default component.exports